<template>
  <div class="rx-used-status">
    <h3 class="shop-name">{{detailInfo.shopName || '/'}}</h3>

    <div class="item">
      <h4 class="audit-status">{{detailInfo.auditStatusStr}}</h4>

      <div class="audit-font">
        <span>审方药师：</span>{{detailInfo.auditPharmacist || '/'}}
      </div>

      <div class="audit-font">
        <span>审核时间：</span>{{detailInfo.auditTime || '/'}}
      </div>
    </div>

    <div class="item">
      <h4>{{detailInfo.useStatusStr}}</h4>

      <ul class="drug-list">
        <div class="drug-item" v-for="(item, index) in detailInfo.drugList" :key="index">
          <div class="drug-left">{{item.drugName}} {{item.drugSpec}}</div>

          <div class="drug-right">× {{item.num}}</div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, toRefs, computed } from 'vue';
import { useRoute } from 'vue-router';
import { Toast } from 'vant';
import { formatAuditStatus, formatUsedStatus } from '@/common/js/computed';
import { getRxUsedStatusApi } from '@/api/promptness/prescription';

export default defineComponent({
  setup() {
    const state = reactive({
      detailInfo: {},
    });

    const route = useRoute();

    // 获取门店取药情况
    const getRxUsedStatus = async (prescriptionId) => {
      const res = await getRxUsedStatusApi({ prescriptionId, });

      if (res.success) {
        state.detailInfo = res.data;
        state.detailInfo.auditStatusStr = computed(() => formatAuditStatus(res.data.auditStatus));
        state.detailInfo.useStatusStr = computed(() => formatUsedStatus(res.data.useStatus));
      }
    };

    onMounted(() => {
      const { prescriptionId, } = route.query;

      if (prescriptionId) {
        getRxUsedStatus(prescriptionId);
      } else {
        Toast('请传入正确参数');
      }
    });

    return {
      ...toRefs(state),
    };
  },
});
</script>

<style lang="scss" scoped>
.rx-used-status {
  @include font(15px, 24px, $base-text-color);

  min-height: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;

  .shop-name {
    padding-bottom: 8px;
    font-size: 17px;
  }

  .item {
    padding: 16px 0 12px;

    ~ .item {
      border-top: 0.5px solid #d0d0d0;
    }
  }

  .audit-status {
    padding-bottom: 8px;
  }

  .audit-font {
    line-height: 32px;

    span {
      color: $info-text-color;
    }
  }

  .drug-item {
    @include flex(flex-start, space-between);

    padding-top: 12px;
  }

  .drug-left {
    max-width: 70vw;
  }

  .drug-right {
    color: $info-text-color;
  }
}
</style>
